var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Selamat datang di Devcode!")]),_c('h2',[_vm._v(" Silahkan klik tombol di bawah ini untuk melihat hasil akhir dari perubahan yang kamu lakukan. ")]),_c('div',{attrs:{"data-cy":"router-button"}},[_c('router-link',{staticClass:"router__btn",attrs:{"to":"/hello"}},[_vm._v("Lihat hasil")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }